import React from "react";
import { Helmet } from "react-helmet-async";

export default function FAQPetiteEnfance() {
  // Fil d'Ariane (Breadcrumb)
  const jsonLdBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://www.loustaletformation.fr/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "FAQ Petite Enfance",
        item: "https://www.loustaletformation.fr/faq",
      },
    ],
  };

  // Données structurées FAQPage
  const jsonLdFaq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Loustalet Formation, c’est quoi ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Loustalet Formation est un site conçu pour aider les professionnel(le)s de la petite enfance à passer la VAE d’auxiliaire de puériculture (DEAP).",
        },
      },
      {
        "@type": "Question",
        name: "Une auxiliaire de puériculture, c’est quoi ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Une auxiliaire de puériculture (AP) est une professionnelle de santé spécialisée dans l’accompagnement et les soins aux jeunes enfants, de la naissance jusqu’à environ 15 ans. Son rôle mêle soin, éveil et accompagnement des familles.",
        },
      },
      {
        "@type": "Question",
        name: "Où exerce une auxiliaire de puériculture ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "En crèche, micro‑crèche et autres EAJE ; à l’hôpital (maternité, pédiatrie, néonatalogie, pédopsychiatrie, etc.) ; en structures spécialisées (pouponnières, IME, centres d’accueil maternel…).",
        },
      },
      {
        "@type": "Question",
        name: "Le DEAP, c’est quoi ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Le DEAP est le Diplôme d’État d’Auxiliaire de Puériculture, indispensable pour exercer. On peut l’obtenir via une formation d’un an en école spécialisée ou via la VAE, sans retourner en formation initiale.",
        },
      },
      {
        "@type": "Question",
        name: "La VAE, c’est quoi ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "La Validation des Acquis de l’Expérience (VAE) est un dispositif français qui permet d’obtenir un diplôme en valorisant les compétences acquises sur le terrain, au travers d’un dossier (livret 2) et d’un oral devant un jury.",
        },
      },
      {
        "@type": "Question",
        name: "Qui peut passer la VAE d’auxiliaire de puériculture ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Toute personne majeure, disposant d’une pièce d’identité française et estimant posséder les compétences et connaissances nécessaires pour exercer en tant qu’auxiliaire de puériculture.",
        },
      },
      {
        "@type": "Question",
        name: "Et si je n’ai pas toutes les connaissances pour obtenir le diplôme d’AP ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Pas d’inquiétude : Loustalet Formation est conçu pour combler les manques. Vous y trouverez des explications sur toutes les étapes de la VAE, des cours, des vidéos et un générateur de QCM pour réviser, ainsi que des RDV individuels et des ateliers en visio.",
        },
      },
      {
        "@type": "Question",
        name: "Quelles sont les étapes d’une VAE ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "1) Se renseigner sur le diplôme (ici : auxiliaire de puériculture). 2) Créer un compte sur France VAE, compléter le dossier et transmettre les pièces (pièce d’identité, attestations, etc.) à l’organisme (ASP/DREETS). 3) Attendre l’accord. 4) Recevoir et remplir le livret 2 consciencieusement. 5) Déposer le livret 2 en ligne. 6) Attendre la convocation. 7) Passer l’oral (environ 50 minutes).",
        },
      },
      {
        "@type": "Question",
        name: "Suite à l’oral, il se passe quoi ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Trois issues : 1) Validation totale : vous recevez le diplôme officiel. 2) Validation partielle : certains blocs de compétences sont validés ; vous pourrez compléter via une nouvelle VAE ciblée ou un cursus partiel en école d’AP. 3) Non‑validation : vous pouvez demander un retour précisant les points à retravailler avant une nouvelle tentative.",
        },
      },
      {
        "@type": "Question",
        name: "Combien de temps pour obtenir sa VAE ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "En moyenne, comptez environ un an entre la création du compte sur FranceVAE.gouv et le passage devant le jury. La durée varie selon votre expérience, votre temps de rédaction du livret 2, votre aisance à rédiger/expliquer, le temps consacré aux révisions, et les délais de convocation dans votre région.",
        },
      },
      {
        "@type": "Question",
        name: "C’est quoi les blocs de compétences ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Le diplôme d’AP est découpé en plusieurs blocs : Bloc 1 (développement de l’enfant, soins du quotidien, repérage de l’urgence) ; Bloc 2 (actes médicaux, surveillance de l’enfant malade, assistance aux soignants, ergonomie) ; Bloc 3 (communication, accueil des stagiaires/collègues) ; Bloc 4 (règles d’hygiène, protocoles, surveillance des anomalies) ; Bloc 5 (contexte professionnel, équipe, hiérarchie, devoirs).",
        },
      },
      {
        "@type": "Question",
        name: "Combien coûte la VAE ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Frais possibles : déplacements et éventuelle nuitée pour l’oral (souvent au chef‑lieu régional). Pour la préparation : 1) organismes de formation avec accompagnement intensif (environ 2000 € / ~30 h visio) ; 2) autonomie totale via ressources en ligne (gratuit) ; 3) solution Loustalet Formation : cours + vidéos validées par des centres d’AP, entraînement via générateur de QCM, RDV individuels avec membres de jury, et ateliers de groupe thématiques.",
        },
      },
      {
        "@type": "Question",
        name: "À quoi servent les visios individuels ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Elles permettent d’échanger avec des membres de jury de la VAE AP : pièges à éviter, choix d’une situation pour le livret 2, organisation du temps, approfondissements de cours/métier, préparation à l’oral, etc. Limite : les membres du jury ne rédigent pas votre dossier.",
        },
      },
      {
        "@type": "Question",
        name: "À quoi servent les visios de groupe ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Elles répondent au besoin de ‘aller plus loin’ dans les pratiques : échanges avec intervenants (ex. LSF bébé, HACCP et hygiène, législation, snoezelen, ateliers parentalité, intégration des familles, sommeil, portage, etc.) et temps spécifiques autour de la VAE.",
        },
      },
      {
        "@type": "Question",
        name: "La VAE représente‑t‑elle beaucoup de travail ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "La VAE est un parcours riche qui invite à questionner ses pratiques et connaissances. La charge perçue varie selon l’expérience, la mémoire, l’aisance rédactionnelle et le temps disponible. Si l’on ne change pas en route, c’est qu’on n’a probablement pas parcouru tout le processus.",
        },
      },
      {
        "@type": "Question",
        name: "Est‑ce grave si je n’ai presque aucune expérience ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Non. Partir avec peu d’expérience mais une forte motivation permet d’avancer vite et dans la bonne direction. Les cours, bloc par bloc, vous donneront les informations qui vous manquent.",
        },
      },
      {
        "@type": "Question",
        name: "Je n’ai pas d’expérience à l’hôpital, est‑ce rédhibitoire ?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Certaines notions ‘soins’ sont plus difficiles sans immersion hospitalière et le bloc 2 est souvent le plus exigeant. Conseils : 1) essayer d’obtenir quelques jours d’observation auprès d’une AP après avoir révisé les soins ; 2) à défaut, échanger avec une AP (réseaux) pour comprendre les tâches et recouper avec vos cours ; 3) à défaut encore, rester humble à l’oral, expliquer votre raisonnement et indiquer que vous demanderez confirmation à l’équipe avant d’agir sur des gestes nouveaux.",
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>FAQ Petite Enfance | L’Oustalet Formation</title>
        <meta
          name="description"
          content="Toutes les réponses sur la VAE d’auxiliaire de puériculture (DEAP) : étapes, durée, coûts, blocs de compétences, visios, et plus encore."
        />
        <link rel="canonical" href="https://www.loustaletformation.fr/faq" />

        {/* Open Graph */}
        <meta property="og:title" content="FAQ Petite Enfance | L’Oustalet Formation" />
        <meta
          property="og:description"
          content="Comprendre la VAE AP : démarches, livret 2, jury, coûts, durées, accompagnements, et conseils concrets pour réussir."
        />
        <meta property="og:url" content="https://www.loustaletformation.fr/faq" />
        <meta property="og:type" content="website" />

        {/* Données structurées */}
        <script type="application/ld+json">{JSON.stringify(jsonLdBreadcrumb)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdFaq)}</script>
      </Helmet>

      <section className="px-6 py-10 max-w-5xl mx-auto">
        {/* Fil d’Ariane */}
        <nav className="text-sm text-gray-500 mb-6" aria-label="Fil d’Ariane">
          <a href="/" className="underline">Accueil</a>
          <span className="mx-2">›</span>
          <span>FAQ Petite Enfance</span>
        </nav>

        <h1 className="text-4xl sm:text-5xl font-bold text-rose-600 mb-4">Foire Aux Questions</h1>
        <p className="text-lg text-gray-700 mb-8">
          Tout savoir sur la VAE d’auxiliaire de puériculture (DEAP) et sur notre accompagnement :
          étapes, durée, coûts, blocs de compétences, visios individuelles et de groupe, et bien plus.
        </p>

        {/* FAQ en accordéon */}
        <div className="space-y-3">
          {[
            {
              q: "Loustalet Formation, c’est quoi ?",
              a: (
                <>
                  Loustalet Formation est un site créé pour aider les professionnel(le)s de la petite enfance à
                  passer la VAE d’auxiliaire de puériculture.
                </>
              ),
            },
            {
              q: "Une auxiliaire de puériculture, c’est quoi ?",
              a: (
                <>
                  Une auxiliaire de puériculture (AP) est une professionnelle de santé spécialisée dans l’accompagnement
                  et les soins aux jeunes enfants, de la naissance jusqu’à 15 ans environ. Son rôle est à la croisée du <strong>soin,
                    de l’éveil et de l’accompagnement des familles</strong>.
                </>
              ),
            },
            {
              q: "Où exerce une auxiliaire de puériculture ?",
              a: (
                <>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>
                      En structure d’accueil de jeunes enfants : crèches, micro-crèche
                    </li>
                    <li>
                      À l’hôpital : en maternité, à pédiatrie, en néonatalogie, en pédopsychiatrie… et tout autre service spécialisé dans les enfants
                    </li>
                    <li>
                      En structures spécialisées : pouponnières, IME, centre d’accueil maternel…
                    </li>
                  </ul>
                </>
              ),
            },
            {
              q: "Le DEAP, c’est quoi ?",
              a: (
                <>
                    <p><strong>C’est le diplôme d’état d’auxiliaire de puériculture</strong> ! C’est ce qui autorise à exercer la fonction d’auxiliaire de puériculture.
                        On peut l’obtenir grâce à une formation dans une école spécialisée qui dure 1 an.</p>
                      <p>  Mais on peut aussi l’obtenir grâce à la VAE sans repasser par la case école !</p>
                </>
              ),
            },
            {
              q: "La VAE, c’est quoi ?",
              a: (
                <>
                 <p> C’est la Validation d’Acquis d’Expérience. C’est un dispositif français unique qui permet d’obtenir un diplôme sans avoir à retourner à l’école.</p>
<p>L’idée est de mettre en avant dans un dossier, puis devant un jury les connaissances que l’on a apprises sur le terrain (grâce à nos expériences).</p>
                </>
              ),
            },
            {
              q: "Qui peut passer la VAE d’auxiliaire de puériculture ?",
              a: (
                <>
                  Toute personne majeure, munie d’une pièce d’identité française qui estime avoir les compétences et les connaissances pour être une bonne auxiliaire de puériculture.
                </>
              ),
            },
            {
              q: "Et si je n’ai pas toutes les connaissances pour avoir le diplôme d’AP ?",
              a: (
                  <>
                      <p>Pas d’inquiétude, Loustalet Formation a été créé pour combler les manques !</p>
                      <p>C’est un site sur lequel vous allez retrouver les explications précises sur les différentes
                          étapes de la VAE mais pas que…</p>
                      <br></br>
                      <p>Vous allez aussi avoir accès à énormément de connaissances, à vous de vous diriger vers ce dont
                          vous pensez avoir besoin de réviser !</p>
                      <br></br>
                      <p>Que ce soit grâce aux vidéos pédagogiques, aux cours ou au générateur de QCM, vous avez le
                          choix pour compléter vos connaissances et être mieux armé pour remplir le dossier et vous
                          sentir prêt(e) pour l’Oral !</p>

                  </>
              ),
            },
            {
              q: "Quelles sont les étapes d’une VAE ?",
              a: (
                <>
                  <ol className="list-decimal pl-6 space-y-1">
                      <li>La première étape est de <strong> se renseigner sur le diplôme</strong> en question (ici auxiliaire de
                          puériculture);</li>
                      <li>Si le diplôme correspond à ce que l’on veut obtenir;</li>
                      <li><strong>Il faut s’inscrire sur la plateforme de FRANCE VAE, créer un compte, remplir les informations demandées</strong> et envoyer toutes les pièces administratives : pièce d’identité, les attestations de stage ou de travail, etc à l’organisme qui organise le passage de la VAE : souvent l’ASP, la DREETS de la région où l’on vit;</li>
                    <li>On attend l’accord de l’ASP;</li>
                    <li>On reçoit en numérique le livret 2 qui est le dossier qui sera ensuite entre les mains du jury lors de l’oral. Il faut donc le remplir consciencieusement;</li>
                    <li>On renvoie le livret 2 rempli de façon numérique sur l’espace créée au début du parcours;</li>
                    <li>On attend la convocation pour le passage devant le jury;</li>
                    <li>Le jour J, on se présente devant un jury, on explique son parcours et on répond aux questions durant 50 min;</li>
                  </ol>
                </>
              ),
            },
            {
              q: "Suite à l’oral, il se passe quoi ?",
              a: (
                <>
                  <ul className="list-disc pl-6 space-y-1 mt-2">
                    <li>
                        <strong>Le jury a considéré que vos connaissances correspondent</strong> bien au diplôme visé et valide votre VAE : Vous recevrez le diplôme officiel par la poste ! Félicitations !!
                    </li>
                    <li>
                      <strong>Le jury pense qu’il vous manque encore des connaissances</strong> à acquérir, mais que vous avez en vous déjà de bonnes bases. Ils peuvent valider un ou plusieurs “blocs de compétences” qui composent le diplôme. Cette validation partielle est valable plusieurs années et vous permet soit de retenter la VAE uniquement pour les parties manquantes, soit d’aller en centre de formation d’auxiliaire de puériculture pour apprendre les parties manquantes (pas besoin de concours d’entrée, etc vous êtes prises automatiquement en cursus partiel).
                    </li>
                    <li>
                      <strong>Le jury considère que les acquis et les connaissances ne sont pas encore assez solides</strong> pour chaque “bloc de compétences” et vous pouvez demander à la suite par retour de mail ce qui n’a pas fonctionné et sur quels sujets vous devez retravailler pour retenter l’expérience de nouveau, mais mieux armé !
                    </li>
                  </ul>
                </>
              ),
            },
            {
              q: "Combien de temps cela prend d’obtenir sa VAE ?",
              a: (
                  <>
                      <p>Il faut compter 1 an en moyenne entre le moment où l’on créer son compte sur FranceVAE.gouv et
                          le moment où l’on passe devant le jury.</p>
                      <br></br>
                      Cela dépend de beaucoup de choses :
                      <li>l’expérience que vous avez et donc les connaissances que vous avez déjà;</li>
                      <li>le temps personnel que vous avez pour la rédaction du livret 2,</li>
                      <li>votre facilité à rédiger et à expliquer,</li>
                      <li>le temps personnel que vous avez pour réviser les connaissances attendues, mais que vous
                          n’avez pas encore,
                      </li>
                      <li>entre les régions les demandes de VAE sont plus ou moins nombreuses et le nombre de passages
                          d’oraux aussi, donc entre l’envoi de votre livret 2 et la convocation devant le jury, il peut
                          se passer quelques petits mois.
                      </li>

                  </>
              ),
            },
            {
              q: "C’est quoi les blocs de compétences ?",
              a: (
                <>
                    <p>Le diplôme d’auxiliaire de puériculture est découpé en plusieurs blocs.
                        Chaque bloc va explorer et expliquer les attentes pour une auxiliaire de puériculture.</p>
                    <br></br>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>
                      <strong>Le bloc 1</strong> Va traiter des connaissances sur le développement de l’enfant, les soins du quotidien que l’on va devoir connaître et aussi la capacité de la professionnelle à repérer une situation d’urgence.
                    </li>
                    <li>
                      <strong>Le bloc 2</strong> Va parler des connaissances en lien avec les actes médicaux, la surveillance d’un enfant malade et aussi le rôle de soutien et d’assistance avec la puéricultrice et les médecins. Il parle également des connaissances nécessaires à ses mouvements pour préserver son corps dans le cadre de son travail (l’ergonomie).
                    </li>
                    <li>
                      <strong>Le bloc 3</strong> Va explorer toutes les connaissances en lien avec la communication et l’accueil des stagiaires ou des collègues.
                    </li>
                    <li>
                      <strong>Le bloc 4</strong> Va traiter des règles d’hygiène, des protocoles et de la surveillance des anomalies.
                    </li>
                    <li>
                      <strong>Le bloc 5</strong> Va expliquer le contexte professionnel dans lequel l’AP travaille, ses collègues, sa hiérarchie, ses devoirs, etc.
                    </li>
                  </ul>
                </>
              ),
            },
            {
              q: "Combien coûte la VAE ?",
              a: (
                <>
                <p>Pour le jour de l’oral, vous aurez les frais de déplacement vers le lieu de l’oral (généralement le chef-lieu de votre région), vous aurez aussi peut-être le coût d’une nuitée si votre convocation est tôt le matin et que vous avez beaucoup de route.</p>
<br/>
<p>Pour la préparation à la VAE, cela dépend de ce dont vous avez besoin :
    <ul className="list-disc pl-6 space-y-1">
        <li>
            Si vous souhaitez être guidé de A à Z avec des dossiers préremplis (mais un risque accru de rater l’oral,
            car le jury sent quand la préparation n’est pas personnelle) : Vous pouvez faire appel à des organismes de
            formations, tels qui coûtent environ 2000€ pour 30h d’accompagnements en visio.
        </li>
        <li>Si vous souhaitez être totalement autonome, vous pouvez trouver toutes les ressources sur internet via des
            vidéos YouTube et des lectures. Cela ne vous coûtera rien !
        </li></ul>
        <br></br>
        <p>Si vous souhaitez une solution alternative avec laquelle vous avez à la fois</p>
    <ul className="list-disc pl-6 space-y-1">
            <li>L’ensemble des connaissances nécessaires pour valider le diplôme d’AP grâce à des cours,
                mais aussi à des vidéos (qui ont été validé par des centres de formations d’AP) pour
                réviser à votre rythme en autonomie
            </li>
            <li>+ une section réservée à de l'entraînement avec un générateur de QCM qui vous permet de réviser de façon
                ludique
            </li>
            <li>+ la possibilité de réserver des rendez-vous individuels avec un membre des jurys de la VAE d’AP pour
                s’entrainer à l’oral ou poser des questions sur la rédaction du livret 2 etc
            </li>
            <li>+ la possibilité de participer à des ateliers en visio de groupe pour aller plus loin dans vos pratiques
                et apprendre grâce à des intervenants chevronnés.
            </li>

    </ul></p>
                </>
              ),
            },
            {
              q: "Ça sert à quoi les visios individuels ?",
              a: (
                  <>
                      <p>Loustalet Formation ce n’est pas qu’un site internet de révision, il y a derrière plusieurs
                          membres de jury de la VAE du diplôme d’auxiliaire de puériculture qui sont disponible pour
                          répondre à toutes vos questions en lien avec le métier d’auxiliaire de puériculture, avec la
                          VAE et la préparation à l’oral, par exemple.</p>
                      <br></br>
                      <p>Les pièges à éviter ?</p>
                      <p>Une aide dans le choix d’une situation pour votre livret 2 ?</p>
                      <p>Des conseils d’organisation du temps ?</p>
                      <p>Des besoins d’approfondissements sur des questions de cours ou sur le métier d’auxiliaire de
                          puériculture ?</p>
                      <br></br>
                      <p>Vous aurez la possibilité d’aborder des sujets très vastes et précis à la fois.</p>
                      <p>La limite est que les membres du jury ne vous donneront jamais un descriptif, ou une partie ou
                          l'entièreté d’un dossier de VAE.</p>
                      <br></br>
                      <p>La VAE est une démarche professionnelle durant laquelle le candidat doit être amené à remettre
                          en
                          question ses acquis, ses habitudes de travail. C’est une démarche qui fait devenir un meilleur
                          professionnel, donc vous n’aurez pas, avec notre plateforme de travail fait à votre place.
                          Seulement
                          des conseils pour vous expliquer ce qui est attendu, sur la méthode ou la rédaction.</p>

                  </>
              ),
                },
                {
                    q: "Ça sert à quoi les visios de groupe ?",
                    a: (
                        <>
                            <p>Les visios de groupe ont été mises en place pour répondre à un besoin de professionnelles
                                qui souhaitent “aller plus loin” dans leurs pratiques.</p>
                            <br></br>
                            <p>Durant ces temps d’échanges en groupe, vous allez pouvoir aborder des sujets variés avec
                                des intervenants compétents dans leurs domaines. Et aussi avoir des temps d’échange en
                                groupe plus spécifiques sur la VAE.</p>
                            <br></br>
                            <p>Exemple de visio de groupe : La langue des signes pour bébé, la démarche HACCP et
                                l’hygiène en cuisine, la législation sur l’accueil des enfants, les ateliers snoezelen,
                                la mise en place d’ateliers de parentalité, l’intégration des familles au sein des
                                structures, le sommeil, le portage etc</p>
                        </>
                    ),
                },{
                    q: "Est-ce que mon employeur doit être au courant de ma démarche de VAE ?",
                    a: (
                        <>

                            <p>Non pas du tout ! C’est une démarche professionnelle personnelle, si vous souhaitez
                                garder le secret et faire la surprise par la suite, vous pouvez.</p>
                            <p>Cependant, il n’y a que peu d’intérêt à cacher cet élément à votre employeur.</p>
                            <br></br>
                            <p>En effet, durant votre parcours, vous serez amené à réfléchir à des situations du
                                quotidien, à échanger avec vos collègues sur leurs impressions et même à leur demander
                                une relecture d’une observation que vous avez faite pour voir si vous n’avez rien oublié
                                !</p>
                            <br></br>
                            <p>De plus, <strong>vous pouvez être fière de votre courage</strong> à vous lancer dans ce
                                parcours !</p>
                            <br></br>
                            <p>Et enfin, pour le jour de l’oral, vous serez amené à être absente, peut être que votre
                                employeur pourra vous laisser cette journée de libre au lieu de piocher dans vos congés
                                ?</p>

                        </>
                    ),
                },
                {
                    q: "Est‑ce que la VAE représente beaucoup de travail ?",
                    a: (
                        <>
                            <p>La VAE est un parcours riche qui va vous permettre de remettre en question votre travail,
                                vos connaissances et donc la(le) professionnel(le) que vous êtes.</p>
                            <br></br>
                            <p>C’est donc un parcours riche, mais prenant.</p>
                            <p>Selon vos expériences, votre facilité à retenir les choses, votre capacité à rédiger ce
                                que vous avez en tête et le temps que vous ayez à y consacrer, personne n’aura le même
                                ressenti sur la charge de travail.</p>
                            <br></br>
                            <p><strong>Mais une chose est sûre : Si vous n’avez pas changé en cours de route c’est que
                                vous
                                n’êtes pas allé au bout du processus.</strong></p>

                        </>
                    ),
                },
                {
                    q: "Est‑ce grave si je n’ai quasiment aucune expérience ?",
                    a: (
                        <>
                            <p>Non.</p>
                            <p>Parfois, lorsque l’on a des années d’expérience derrière soi, il est difficile de se
                                remettre en question et donc d’acquérir les compétences demandées pour le diplôme
                                d’auxiliaire de puériculture.</p>
                            <br></br>
                            <p>Quand on part de peu et que l’on a que l’envie, on peut avancer vite et surtout avancer
                                dans la bonne direction !</p>
                            <br></br>
                            <p>Les cours sont là, bloc par bloc, pour vous donner les informations qui vous manquent
                                !</p>

                        </>
                    ),
                },
                {
                    q: "Je n’ai pas d’expérience à l’hôpital, est‑ce rédhibitoire ?",
                    a: (
                        <>
                            <p>Certaines connaissances utiles uniquement en milieu hospitalier sont compliquées à
                                comprendre sans
                                avoir été plongées dans le quotidien d’un AP en service de soin.</p>
                            <br></br>
                            <p>Cependant, il est possible de valider les compétences nécessaires spécifiques aux soins
                                médicaux
                                sans avoir été à l’hôpital. Je ne vous cache pas que le bloc de compétence numéro 2 qui
                                est
                                justement là-dessus est le plus difficile à valider.</p>
                            <br></br>
                            <strong>Mais voici quelques conseils : </strong>
                            <li>Essayez d’obtenir quelques jours de stage dans un milieu hospitalier auprès d’une
                                auxiliaire de puériculture près de chez vous. Le mieux est de le caler après avoir
                                révisé un maximum de choses sur les soins médicaux avant d’y aller pour pouvoir se
                                concentrer sur le travail de l’AP et ne pas vous retrouver noyé sous les termes
                                médicaux. Si vous devez le faire pendant vos jours de repos, faites-le quand même
                                ! <strong>On parle de votre avenir !</strong></li>
                            <li>Si vous n’arrivez pas à obtenir de stage en milieu hospitalier chercher autour de vous
                                une personne qui serait déjà auxiliaire de puériculture (même si cela implique de la
                                trouver sur les réseaux sociaux), demandez-lui de vous expliquer son travail, les tâches
                                qu’elle a le droit de faire ou non, recouper tout cela avec vos cours etc.
                            </li>
                            <li>Si vous n’avez rien de tout cela, pas de panique, réviser ce qui est indiqué dans les
                                vidéos spécifiquement le bloc 2 et rester humble. Si une question vous est posée et que
                                vous n’avez pas la réponse, expliquer ce qui vous semble le mieux. N’hésitez pas à dire
                                que vous demanderez d’abord confirmation à vos collègues avant de vous lancer si c’est
                                quelque chose de nouveau.
                            </li>
                        </>
                    ),
                },
                ].map(({q, a}, idx) => (
                <details key={idx} className="group border rounded-xl p-4">
                    <summary className="font-medium cursor-pointer flex items-center justify-between">
                        <span>{q}</span>
                        <span className="ml-4 text-gray-400 group-open:rotate-180 transition-transform">▾</span>
                    </summary>
                    <div className="mt-3 text-gray-700 text-sm">{a}</div>
                </details>
                ))}
            </div>

            {/* CTA */}
            <div className="mt-10 flex flex-wrap gap-3">
                <a href="/vae"
                   className="inline-block px-5 py-3 rounded-2xl border border-rose-600 text-rose-700 font-semibold">
                    Comprendre la VAE AP
                </a>
                <a href="/tarifs"
                   className="inline-block px-5 py-3 rounded-2xl bg-rose-600 text-white font-semibold shadow">
                    Voir les tarifs
                </a>
            </div>
        </section>
    </>
    );
    }
